import React from 'react'

const IconRecoverySealSeafoam = ({
  className
}: {
  className: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
    >
      <g filter="url(#filter0_b_10119_197651)">
        <path
          d="M18.7078 0.776856C20.057 -0.268999 21.943 -0.268999 23.2922 0.776856L26.2969 3.10606C26.9137 3.58417 27.6645 3.85745 28.4443 3.88765L32.2433 4.03478C33.9491 4.10085 35.3938 5.31316 35.7551 6.98157L36.5597 10.6972C36.7248 11.4599 37.1243 12.1519 37.7023 12.6763L40.5179 15.2309C41.7821 16.378 42.1096 18.2354 41.3139 19.7457L39.5419 23.1092C39.1781 23.7996 39.0394 24.5865 39.1451 25.3597L39.6599 29.1265C39.891 30.8178 38.948 32.4512 37.3677 33.0967L33.8481 34.5342C33.1257 34.8293 32.5136 35.3429 32.0976 36.0031L30.0707 39.2196C29.1606 40.6638 27.3883 41.3088 25.7628 40.7875L22.1426 39.6265C21.3995 39.3881 20.6005 39.3881 19.8574 39.6265L16.2372 40.7875C14.6117 41.3088 12.8394 40.6638 11.9293 39.2196L9.90243 36.0031C9.48638 35.3429 8.8743 34.8293 8.15186 34.5342L4.63234 33.0967C3.05201 32.4512 2.109 30.8178 2.34015 29.1265L2.85493 25.3597C2.9606 24.5865 2.82185 23.7996 2.45811 23.1092L0.686056 19.7457C-0.109628 18.2354 0.217876 16.378 1.48213 15.2309L4.29771 12.6763C4.87566 12.1519 5.27517 11.4599 5.44032 10.6972L6.24489 6.98156C6.60616 5.31316 8.05094 4.10085 9.75673 4.03478L13.5557 3.88765C14.3355 3.85745 15.0863 3.58417 15.7031 3.10606L18.7078 0.776856Z"
          fill="#CFE9E9"
        />
        <path
          d="M19.3921 28.8239C19.4712 28.8231 19.537 28.7636 19.544 28.6849C19.6228 27.7966 20.0332 22.7877 19.6963 18.344C19.286 12.9331 14.5561 12.9657 13.7879 13.007C13.7228 13.0105 13.6731 13.0549 13.6596 13.1187C13.5308 13.7296 12.9214 17.0169 13.3495 22.7689C13.8046 28.8818 17.7296 28.8411 19.3197 28.8246C19.3444 28.8243 19.3685 28.8241 19.3921 28.8239Z"
          fill="#232452"
        />
        <path
          d="M28.8355 13.1669C28.8353 13.0824 28.767 13.014 28.6824 13.014H27.7149C27.2752 13.014 22.2178 13.0141 21.8662 17.6304C21.8106 18.3607 21.7718 19.1229 21.7456 19.8903C21.7427 19.9768 21.8117 20.0485 21.8983 20.0485H24.6641C24.6876 20.0485 24.7148 20.0488 24.7453 20.049C25.5703 20.0562 28.8391 20.0846 28.8391 16.0322C28.8391 14.8327 28.8365 13.5915 28.8355 13.1669Z"
          fill="#232452"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6253 25.4434C21.6253 23.3805 23.119 21.8868 25.1819 21.8868C27.2448 21.8868 28.7385 23.3805 28.7385 25.4434C28.7385 27.5063 27.2448 29 25.1819 29C23.119 29 21.6253 27.5063 21.6253 25.4434ZM23.326 25.4536C23.326 24.3629 24.1057 23.5628 25.1822 23.5628C26.2586 23.5628 27.0384 24.3629 27.0384 25.4536C27.0384 26.5443 26.2586 27.3445 25.1822 27.3445C24.1057 27.3445 23.326 26.5443 23.326 25.4536Z"
          fill="#232452"
        />
        <path
          d="M21.6669 20.0487L21.6638 20.0517V20.0487H21.6669Z"
          fill="#232452"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_10119_197651"
          x="-5.74609"
          y="-6.00781"
          width="53.4922"
          height="53.0078"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="3"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_10119_197651"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_10119_197651"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconRecoverySealSeafoam
